export const RESET_RELATIONSHIP_DATA = 'RESET_RELATIONSHIP_DATA';
export const SET_RELATIONSHIP_DATA = 'FETCH_RELATIONSHIP_DATA_SUCCESS';
export const CHANGE_REFETCH_STATUS = 'CHANGE_REFETCH_STATUS';
export const APPEND_RELATIONSHIP_LANE_DATA = 'APPEND_RELATIONSHIP_LANE_DATA';
